import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    video:
      "https://www.youtube.com/embed/2fl6RujPaJM?si=ooKtdj-iR1Dcyh1d",
    name: "Zulfah Alumni",
    role: "Software Engineer",
    company: "Flutterwave",
    quote:
      "Thanks to Zulfah, my life has been completely transformed. I went from zero knowledge of tech to becoming a full-stack developer. This program opened doors I never thought possible, and today, I am proud to be part of Flutterwave as a software engineer.",
  },
  {
    video:
      "https://www.youtube.com/embed/HRNUatoLjt4?si=TO_XatAZAb5shp4v",
    name: "Zulfah Alumni",
    role: "Technology Professional",
    company: "Zulfah Alumni",
    quote:
      "Before Zulfah, I had no prior experience with programming. The mentorship was second to none, and the curriculum was thoughtfully structured. Zulfah helped me rewrite my story and build a future I’m proud of.",
  },
  {
    video:
      "https://www.youtube.com/embed/-J1gJw9ffGE?si=n-IGJU1eQcVXnl71",
    name: "Zulfah Alumni",
    role: "Frontend Engineer",
    company: "HerVest",
    quote:
      "After my undergrad, I opted for a career switch and Zulfah helped me build a career in Software Engineering. I now work as a frontend engineer at HerVest. It’s been an amazing journey from biochemistry to software development.",
  },
];

const Testimonial = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const active = testimonials[activeIndex];

  return (
    <section className="relative overflow-hidden bg-[#07171c] py-28 md:py-36">

      {/* =====================================================
          BACKGROUND
      ===================================================== */}

      <div className="absolute inset-0">

        {/* Teal glow */}
        <div className="absolute -top-40 -left-40 w-[550px] h-[550px] rounded-full bg-[#59b5cd]/15 blur-[150px]" />

        {/* Gold glow */}
        <div className="absolute -bottom-40 -right-40 w-[550px] h-[550px] rounded-full bg-[#ecb32c]/10 blur-[150px]" />

        {/* Subtle grid */}
        <div
          className="absolute inset-0 opacity-[0.035]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        />

      </div>


      <div className="relative z-10 max-w-7xl mx-auto px-6">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <motion.div
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >

          <div className="inline-flex items-center gap-3 mb-6">

            <span className="w-8 h-[1px] bg-[#ecb32c]" />

            <span className="text-[#ecb32c] text-xs font-bold uppercase tracking-[0.3em]">
              Voices of Zulfah
            </span>

            <span className="w-8 h-[1px] bg-[#ecb32c]" />

          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white leading-tight">

            Don't take our word
            <br />

            <span className="bg-gradient-to-r from-[#59b5cd] to-[#ecb32c] bg-clip-text text-transparent">
              for it.
            </span>

          </h2>

          <p className="mt-6 text-white/55 text-base md:text-lg leading-relaxed">
            Hear directly from people who started their journey at Zulfah
            and went on to build careers, businesses and futures in technology.
          </p>

        </motion.div>


        {/* =====================================================
            FEATURED TESTIMONIAL
        ===================================================== */}

        <div className="grid lg:grid-cols-[1.25fr_0.75fr] gap-8 items-stretch">

          {/* =================================================
              VIDEO
          ================================================= */}

          <motion.div
            className="relative rounded-[2rem] overflow-hidden border border-white/10 bg-black shadow-2xl"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >

            {/* Video */}

            <AnimatePresence mode="wait">

              <motion.div
                key={activeIndex}
                initial={{ opacity: 0, scale: 1.03 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="aspect-video w-full"
              >

                <iframe
                  src={`${active.video}&enablejsapi=1`}
                  title="Zulfah Academy testimonial"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                />

              </motion.div>

            </AnimatePresence>


            {/* Video badge */}

            <div className="absolute top-5 left-5 pointer-events-none">

              <div className="flex items-center gap-2 bg-black/60 backdrop-blur-md border border-white/10 rounded-full px-4 py-2">

                <span className="w-2 h-2 bg-[#59b5cd] rounded-full animate-pulse" />

                <span className="text-white text-xs font-semibold">
                  ZULFAH STORY
                </span>

              </div>

            </div>

          </motion.div>


          {/* =================================================
              QUOTE CARD
          ================================================= */}

          <motion.div
            className="relative rounded-[2rem] border border-white/10 bg-white/[0.045] backdrop-blur-xl p-8 md:p-10 flex flex-col justify-between overflow-hidden"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >

            {/* Decorative quote */}

            <div className="absolute -top-8 -right-2 text-[180px] leading-none font-serif text-[#59b5cd]/10 pointer-events-none">
              “
            </div>


            <div className="relative z-10">

              <div className="text-[#ecb32c] text-5xl font-serif leading-none mb-5">
                “
              </div>

              <AnimatePresence mode="wait">

                <motion.p
                  key={activeIndex}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -15 }}
                  transition={{ duration: 0.35 }}
                  className="text-white/80 text-lg md:text-xl leading-relaxed"
                >
                  {active.quote}
                </motion.p>

              </AnimatePresence>

            </div>


            {/* Person */}

            <div className="relative z-10 mt-10">

              <div className="w-12 h-[2px] bg-[#ecb32c] mb-5" />

              <p className="text-white font-bold">
                {active.name}
              </p>

              <p className="text-[#59b5cd] text-sm mt-1">
                {active.role}
              </p>

              <p className="text-white/40 text-sm mt-1">
                {active.company}
              </p>

            </div>

          </motion.div>

        </div>


        {/* =====================================================
            TESTIMONIAL SELECTORS
        ===================================================== */}

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">

          {testimonials.map((item, index) => (

            <motion.button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`
                relative text-left p-5 rounded-2xl border
                transition-all duration-300
                overflow-hidden
                ${
                  activeIndex === index
                    ? "bg-white/[0.09] border-[#59b5cd]/50"
                    : "bg-white/[0.025] border-white/10 hover:border-white/20"
                }
              `}
              whileHover={{ y: -4 }}
            >

              {/* Active indicator */}

              {activeIndex === index && (
                <motion.div
                  layoutId="testimonial-active"
                  className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#59b5cd] to-[#ecb32c]"
                />
              )}

              <div className="flex items-center gap-4">

                {/* Number */}

                <div
                  className={`
                    w-11 h-11 rounded-xl flex items-center justify-center
                    font-black text-sm
                    ${
                      activeIndex === index
                        ? "bg-[#ecb32c] text-[#07171c]"
                        : "bg-white/5 text-white/40"
                    }
                  `}
                >
                  0{index + 1}
                </div>


                <div>

                  <p
                    className={`font-bold ${
                      activeIndex === index
                        ? "text-white"
                        : "text-white/60"
                    }`}
                  >
                    {item.role}
                  </p>

                  <p className="text-white/30 text-xs mt-1">
                    {item.company}
                  </p>

                </div>

              </div>

            </motion.button>

          ))}

        </div>


        {/* =====================================================
            BOTTOM SOCIAL PROOF
        ===================================================== */}

        <motion.div
          className="mt-20 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >

          <div className="text-center md:text-left">

            <p className="text-white font-bold text-lg">
              Your story could be next.
            </p>

            <p className="text-white/40 text-sm mt-1">
              Start building your future with Zulfah Academy.
            </p>

          </div>


          <a
            href="/get-started"
            className="
              inline-flex
              items-center
              gap-3
              px-7
              py-4
              rounded-xl
              bg-[#ecb32c]
              text-[#07171c]
              font-bold
              hover:bg-[#f2c44f]
              hover:scale-[1.03]
              transition-all
              shadow-lg
              shadow-[#ecb32c]/10
            "
          >
            Join Zulfah

            <span className="text-xl">
              →
            </span>

          </a>

        </motion.div>

      </div>

    </section>
  );
};

export default Testimonial;